import React from 'react';
import { TimezoneContext, TimezoneSetContext } from './timezone.context';


export const useTimezone = () => {
  return React.useContext(TimezoneContext);
};


export const useSetTimezone = () => {
  return React.useContext(TimezoneSetContext);
};
